// Define the country data first, then export as a typed object
const countryDataRaw = {
    AD: {
        countryCode: 'AD',
        countryName: {
            en: 'Andorra',
            fi: 'Andorra',
            sv: 'Andorra',
        },
    },
    AE: {
        countryCode: 'AE',
        countryName: {
            en: 'United Arab Emirates',
            fi: 'Arabiemiirikunnat',
            sv: 'Förenade arabemiraten',
        },
    },
    AF: {
        countryCode: 'AF',
        countryName: {
            en: 'Afghanistan',
            fi: 'Afganistan',
            sv: 'Afghanistan',
        },
    },
    AG: {
        countryCode: 'AG',
        countryName: {
            en: 'Antigua and Barbuda',
            fi: 'Antigua ja Barbuda',
            sv: 'Antigua och Barbuda',
        },
    },
    AI: {
        countryCode: 'AI',
        countryName: {
            en: 'Anguilla',
            fi: 'Anguilla',
            sv: 'Anguilla',
        },
    },
    AL: {
        countryCode: 'AL',
        countryName: {
            en: 'Albania',
            fi: 'Albania',
            sv: 'Albanien',
        },
    },
    AM: {
        countryCode: 'AM',
        countryName: {
            en: 'Armenia',
            fi: 'Armenia',
            sv: 'Armenien',
        },
    },
    AO: {
        countryCode: 'AO',
        countryName: {
            en: 'Angola',
            fi: 'Angola',
            sv: 'Angola',
        },
    },
    AQ: {
        countryCode: 'AQ',
        countryName: {
            en: 'Antarctica',
            fi: 'Antarktis',
            sv: 'Antarktis',
        },
    },
    AR: {
        countryCode: 'AR',
        countryName: {
            en: 'Argentina',
            fi: 'Argentiina',
            sv: 'Argentina',
        },
    },
    AS: {
        countryCode: 'AS',
        countryName: {
            en: 'American Samoa',
            fi: 'Amerikan Samoa',
            sv: 'Amerikanska Samoa',
        },
    },
    AT: {
        countryCode: 'AT',
        countryName: {
            en: 'Austria',
            fi: 'Itävalta',
            sv: 'Österrike',
        },
    },
    AU: {
        countryCode: 'AU',
        countryName: {
            en: 'Australia',
            fi: 'Australia',
            sv: 'Australien',
        },
    },
    AW: {
        countryCode: 'AW',
        countryName: {
            en: 'Aruba',
            fi: 'Aruba',
            sv: 'Aruba',
        },
    },
    AX: {
        countryCode: 'AX',
        countryName: {
            en: 'Åland Islands',
            fi: 'Ahvenanmaa',
            sv: 'Åland',
        },
    },
    AZ: {
        countryCode: 'AZ',
        countryName: {
            en: 'Azerbaijan',
            fi: 'Azerbaidžan',
            sv: 'Azerbajdzjan',
        },
    },
    BA: {
        countryCode: 'BA',
        countryName: {
            en: 'Bosnia and Herzegovina',
            fi: 'Bosnia ja Hertsegovina',
            sv: 'Bosnien och Hercegovina',
        },
    },
    BB: {
        countryCode: 'BB',
        countryName: {
            en: 'Barbados',
            fi: 'Barbados',
            sv: 'Barbados',
        },
    },
    BD: {
        countryCode: 'BD',
        countryName: {
            en: 'Bangladesh',
            fi: 'Bangladesh',
            sv: 'Bangladesh',
        },
    },
    BE: {
        countryCode: 'BE',
        countryName: {
            en: 'Belgium',
            fi: 'Belgia',
            sv: 'Belgien',
        },
    },
    BF: {
        countryCode: 'BF',
        countryName: {
            en: 'Burkina Faso',
            fi: 'Burkina Faso',
            sv: 'Burkina Faso',
        },
    },
    BG: {
        countryCode: 'BG',
        countryName: {
            en: 'Bulgaria',
            fi: 'Bulgaria',
            sv: 'Bulgarien',
        },
    },
    BH: {
        countryCode: 'BH',
        countryName: {
            en: 'Bahrain',
            fi: 'Bahrain',
            sv: 'Bahrain',
        },
    },
    BI: {
        countryCode: 'BI',
        countryName: {
            en: 'Burundi',
            fi: 'Burundi',
            sv: 'Burundi',
        },
    },
    BJ: {
        countryCode: 'BJ',
        countryName: {
            en: 'Benin',
            fi: 'Benin',
            sv: 'Benin',
        },
    },
    BL: {
        countryCode: 'BL',
        countryName: {
            en: 'Saint Barthélemy',
            fi: 'Saint Barthélemy',
            sv: 'Saint-Barthélemy',
        },
    },
    BM: {
        countryCode: 'BM',
        countryName: {
            en: 'Bermuda',
            fi: 'Bermuda',
            sv: 'Bermuda',
        },
    },
    BN: {
        countryCode: 'BN',
        countryName: {
            en: 'Brunei Darussalam',
            fi: 'Brunei',
            sv: 'Brunei',
        },
    },
    BO: {
        countryCode: 'BO',
        countryName: {
            en: 'Bolivia',
            fi: 'Bolivia',
            sv: 'Bolivia',
        },
    },
    BQ: {
        countryCode: 'BQ',
        countryName: {
            en: 'Bonaire, Sint Eustatius and Saba',
            fi: 'Alankomaiden Karibia',
            sv: 'Bonaire, Sint Eustatius and Saba',
        },
    },
    BR: {
        countryCode: 'BR',
        countryName: {
            en: 'Brazil',
            fi: 'Brasilia',
            sv: 'Brasilien',
        },
    },
    BS: {
        countryCode: 'BS',
        countryName: {
            en: 'Bahamas',
            fi: 'Bahama',
            sv: 'Bahamas',
        },
    },
    BT: {
        countryCode: 'BT',
        countryName: {
            en: 'Bhutan',
            fi: 'Bhutan',
            sv: 'Bhutan',
        },
    },
    BV: {
        countryCode: 'BV',
        countryName: {
            en: 'Bouvet Island',
            fi: 'Bouvet’nsaari',
            sv: 'Bouvetön',
        },
    },
    BW: {
        countryCode: 'BW',
        countryName: {
            en: 'Botswana',
            fi: 'Botswana',
            sv: 'Botswana',
        },
    },
    BY: {
        countryCode: 'BY',
        countryName: {
            en: 'Belarus',
            fi: 'Valko-Venäjä',
            sv: 'Belarus',
        },
    },
    BZ: {
        countryCode: 'BZ',
        countryName: {
            en: 'Belize',
            fi: 'Belize',
            sv: 'Belize',
        },
    },
    CA: {
        countryCode: 'CA',
        countryName: {
            en: 'Canada',
            fi: 'Kanada',
            sv: 'Kanada',
        },
    },
    CC: {
        countryCode: 'CC',
        countryName: {
            en: 'Cocos (Keeling) Islands',
            fi: 'Kookossaaret',
            sv: 'Kokosöarna',
        },
    },
    CD: {
        countryCode: 'CD',
        countryName: {
            en: 'Democratic Republic of the Congo',
            fi: 'Kongon demokraattinen tasavalta',
            sv: 'Kongo-Kinshasa',
        },
    },
    CF: {
        countryCode: 'CF',
        countryName: {
            en: 'Central African Republic',
            fi: 'Keski-Afrikan tasavalta',
            sv: 'Centralafrikanska republiken',
        },
    },
    CG: {
        countryCode: 'CG',
        countryName: {
            en: 'Congo',
            fi: 'Kongon tasavalta',
            sv: 'Kongo-Brazzaville',
        },
    },
    CH: {
        countryCode: 'CH',
        countryName: {
            en: 'Switzerland',
            fi: 'Sveitsi',
            sv: 'Schweiz',
        },
    },
    CI: {
        countryCode: 'CI',
        countryName: {
            en: "Côte d'Ivoire",
            fi: 'Norsunluurannikko',
            sv: 'Elfenbenskusten',
        },
    },
    CK: {
        countryCode: 'CK',
        countryName: {
            en: 'Cook Islands',
            fi: 'Cookinsaaret',
            sv: 'Cooköarna',
        },
    },
    CL: {
        countryCode: 'CL',
        countryName: {
            en: 'Chile',
            fi: 'Chile',
            sv: 'Chile',
        },
    },
    CM: {
        countryCode: 'CM',
        countryName: {
            en: 'Cameroon',
            fi: 'Kamerun',
            sv: 'Kamerun',
        },
    },
    CN: {
        countryCode: 'CN',
        countryName: {
            en: 'China',
            fi: 'Kiina',
            sv: 'Kina',
        },
    },
    CO: {
        countryCode: 'CO',
        countryName: {
            en: 'Colombia',
            fi: 'Kolumbia',
            sv: 'Colombia',
        },
    },
    CR: {
        countryCode: 'CR',
        countryName: {
            en: 'Costa Rica',
            fi: 'Costa Rica',
            sv: 'Costa Rica',
        },
    },
    CU: {
        countryCode: 'CU',
        countryName: {
            en: 'Cuba',
            fi: 'Kuuba',
            sv: 'Kuba',
        },
    },
    CV: {
        countryCode: 'CV',
        countryName: {
            en: 'Cabo Verde',
            fi: 'Kap Verde',
            sv: 'Kap Verde',
        },
    },
    CW: {
        countryCode: 'CW',
        countryName: {
            en: 'Curaçao',
            fi: 'Curaçao',
            sv: 'Curaçao',
        },
    },
    CX: {
        countryCode: 'CX',
        countryName: {
            en: 'Christmas Island',
            fi: 'Joulusaari',
            sv: 'Julön',
        },
    },
    CY: {
        countryCode: 'CY',
        countryName: {
            en: 'Cyprus',
            fi: 'Kypros',
            sv: 'Cypern',
        },
    },
    CZ: {
        countryCode: 'CZ',
        countryName: {
            en: 'Czechia',
            fi: 'Tšekki',
            sv: 'Tjeckien',
        },
    },
    DE: {
        countryCode: 'DE',
        countryName: {
            en: 'Germany',
            fi: 'Saksa',
            sv: 'Tyskland',
        },
    },
    DJ: {
        countryCode: 'DJ',
        countryName: {
            en: 'Djibouti',
            fi: 'Djibouti',
            sv: 'Djibouti',
        },
    },
    DK: {
        countryCode: 'DK',
        countryName: {
            en: 'Denmark',
            fi: 'Tanska',
            sv: 'Danmark',
        },
    },
    DM: {
        countryCode: 'DM',
        countryName: {
            en: 'Dominica',
            fi: 'Dominica',
            sv: 'Dominica',
        },
    },
    DO: {
        countryCode: 'DO',
        countryName: {
            en: 'Dominican Republic',
            fi: 'Dominikaaninen tasavalta',
            sv: 'Dominikanska republiken',
        },
    },
    DZ: {
        countryCode: 'DZ',
        countryName: {
            en: 'Algeria',
            fi: 'Algeria',
            sv: 'Algeriet',
        },
    },
    EC: {
        countryCode: 'EC',
        countryName: {
            en: 'Ecuador',
            fi: 'Ecuador',
            sv: 'Ecuador',
        },
    },
    EE: {
        countryCode: 'EE',
        countryName: {
            en: 'Estonia',
            fi: 'Viro',
            sv: 'Estland',
        },
    },
    EG: {
        countryCode: 'EG',
        countryName: {
            en: 'Egypt',
            fi: 'Egypti',
            sv: 'Egypten',
        },
    },
    EH: {
        countryCode: 'EH',
        countryName: {
            en: 'Western Sahara',
            fi: 'Länsi-Sahara',
            sv: 'Västsahara',
        },
    },
    ER: {
        countryCode: 'ER',
        countryName: {
            en: 'Eritrea',
            fi: 'Eritrea',
            sv: 'Eritrea',
        },
    },
    ES: {
        countryCode: 'ES',
        countryName: {
            en: 'Spain',
            fi: 'Espanja',
            sv: 'Spanien',
        },
    },
    ET: {
        countryCode: 'ET',
        countryName: {
            en: 'Ethiopia',
            fi: 'Etiopia',
            sv: 'Etiopien',
        },
    },
    FI: {
        countryCode: 'FI',
        countryName: {
            en: 'Finland',
            fi: 'Suomi',
            sv: 'Finland',
        },
    },
    FJ: {
        countryCode: 'FJ',
        countryName: {
            en: 'Fiji',
            fi: 'Fidži',
            sv: 'Fiji',
        },
    },
    FK: {
        countryCode: 'FK',
        countryName: {
            en: 'Falkland Islands',
            fi: 'Falklandinsaaret',
            sv: 'Falklandsöarna',
        },
    },
    FM: {
        countryCode: 'FM',
        countryName: {
            en: 'Federated States of Micronesia',
            fi: 'Mikronesian liittovaltio',
            sv: 'Mikronesiska federationen',
        },
    },
    FO: {
        countryCode: 'FO',
        countryName: {
            en: 'Faroe Islands',
            fi: 'Färsaaret',
            sv: 'Färöarna',
        },
    },
    FR: {
        countryCode: 'FR',
        countryName: {
            en: 'France',
            fi: 'Ranska',
            sv: 'Frankrike',
        },
    },
    GA: {
        countryCode: 'GA',
        countryName: {
            en: 'Gabon',
            fi: 'Gabon',
            sv: 'Gabon',
        },
    },
    GB: {
        countryCode: 'GB',
        countryName: {
            en: 'United Kingdom',
            fi: 'Yhdistynyt kuningaskunta',
            sv: 'Storbritannien',
        },
    },
    GD: {
        countryCode: 'GD',
        countryName: {
            en: 'Grenada',
            fi: 'Grenada',
            sv: 'Grenada',
        },
    },
    GE: {
        countryCode: 'GE',
        countryName: {
            en: 'Georgia',
            fi: 'Georgia',
            sv: 'Georgien',
        },
    },
    GF: {
        countryCode: 'GF',
        countryName: {
            en: 'French Guiana',
            fi: 'Ranskan Guayana',
            sv: 'Franska Guyana',
        },
    },
    GG: {
        countryCode: 'GG',
        countryName: {
            en: 'Guernsey',
            fi: 'Guernsey',
            sv: 'Guernsey',
        },
    },
    GH: {
        countryCode: 'GH',
        countryName: {
            en: 'Ghana',
            fi: 'Ghana',
            sv: 'Ghana',
        },
    },
    GI: {
        countryCode: 'GI',
        countryName: {
            en: 'Gibraltar',
            fi: 'Gibraltar',
            sv: 'Gibraltar',
        },
    },
    GL: {
        countryCode: 'GL',
        countryName: {
            en: 'Greenland',
            fi: 'Grönlanti',
            sv: 'Grönland',
        },
    },
    GM: {
        countryCode: 'GM',
        countryName: {
            en: 'Gambia',
            fi: 'Gambia',
            sv: 'Gambia',
        },
    },
    GN: {
        countryCode: 'GN',
        countryName: {
            en: 'Guinea',
            fi: 'Guinea',
            sv: 'Guinea',
        },
    },
    GP: {
        countryCode: 'GP',
        countryName: {
            en: 'Guadeloupe',
            fi: 'Guadeloupe',
            sv: 'Guadeloupe',
        },
    },
    GQ: {
        countryCode: 'GQ',
        countryName: {
            en: 'Equatorial Guinea',
            fi: 'Päiväntasaajan Guinea',
            sv: 'Ekvatorialguinea',
        },
    },
    GR: {
        countryCode: 'GR',
        countryName: {
            en: 'Greece',
            fi: 'Kreikka',
            sv: 'Grekland',
        },
    },
    GS: {
        countryCode: 'GS',
        countryName: {
            en: 'South Georgia and the South Sandwich Islands',
            fi: 'Etelä-Georgia ja Eteläiset Sandwichsaaret',
            sv: 'Sydgeorgien och Sydsandwichöarna',
        },
    },
    GT: {
        countryCode: 'GT',
        countryName: {
            en: 'Guatemala',
            fi: 'Guatemala',
            sv: 'Guatemala',
        },
    },
    GU: {
        countryCode: 'GU',
        countryName: {
            en: 'Guam',
            fi: 'Guam',
            sv: 'Guam',
        },
    },
    GW: {
        countryCode: 'GW',
        countryName: {
            en: 'Guinea-Bissau',
            fi: 'Guinea-Bissau',
            sv: 'Guinea-Bissau',
        },
    },
    GY: {
        countryCode: 'GY',
        countryName: {
            en: 'Guyana',
            fi: 'Guyana',
            sv: 'Guyana',
        },
    },
    HK: {
        countryCode: 'HK',
        countryName: {
            en: 'Hong Kong',
            fi: 'Hongkong',
            sv: 'Hongkong',
        },
    },
    HM: {
        countryCode: 'HM',
        countryName: {
            en: 'Heard Island and McDonald Islands',
            fi: 'Heard ja McDonaldinsaaret',
            sv: 'Heard- och McDonaldöarna',
        },
    },
    HN: {
        countryCode: 'HN',
        countryName: {
            en: 'Honduras',
            fi: 'Honduras',
            sv: 'Honduras',
        },
    },
    HR: {
        countryCode: 'HR',
        countryName: {
            en: 'Croatia',
            fi: 'Kroatia',
            sv: 'Kroatien',
        },
    },
    HT: {
        countryCode: 'HT',
        countryName: {
            en: 'Haiti',
            fi: 'Haiti',
            sv: 'Haiti',
        },
    },
    HU: {
        countryCode: 'HU',
        countryName: {
            en: 'Hungary',
            fi: 'Unkari',
            sv: 'Ungern',
        },
    },
    ID: {
        countryCode: 'ID',
        countryName: {
            en: 'Indonesia',
            fi: 'Indonesia',
            sv: 'Indonesien',
        },
    },
    IE: {
        countryCode: 'IE',
        countryName: {
            en: 'Ireland',
            fi: 'Irlanti',
            sv: 'Irland',
        },
    },
    IL: {
        countryCode: 'IL',
        countryName: {
            en: 'Israel',
            fi: 'Israel',
            sv: 'Israel',
        },
    },
    IM: {
        countryCode: 'IM',
        countryName: {
            en: 'Isle of Man',
            fi: 'Mansaari',
            sv: 'Isle of Man',
        },
    },
    IN: {
        countryCode: 'IN',
        countryName: {
            en: 'India',
            fi: 'Intia',
            sv: 'Indien',
        },
    },
    IO: {
        countryCode: 'IO',
        countryName: {
            en: 'British Indian Ocean Territory',
            fi: 'Brittiläinen Intian valtameren alue',
            sv: 'Brittiska territoriet i Indiska oceanen',
        },
    },
    IQ: {
        countryCode: 'IQ',
        countryName: {
            en: 'Iraq',
            fi: 'Irak',
            sv: 'Irak',
        },
    },
    IR: {
        countryCode: 'IR',
        countryName: {
            en: 'Iran',
            fi: 'Iran',
            sv: 'Iran',
        },
    },
    IS: {
        countryCode: 'IS',
        countryName: {
            en: 'Iceland',
            fi: 'Islanti',
            sv: 'Island',
        },
    },
    IT: {
        countryCode: 'IT',
        countryName: {
            en: 'Italy',
            fi: 'Italia',
            sv: 'Italien',
        },
    },
    JE: {
        countryCode: 'JE',
        countryName: {
            en: 'Jersey',
            fi: 'Jersey',
            sv: 'Jersey',
        },
    },
    JM: {
        countryCode: 'JM',
        countryName: {
            en: 'Jamaica',
            fi: 'Jamaika',
            sv: 'Jamaica',
        },
    },
    JO: {
        countryCode: 'JO',
        countryName: {
            en: 'Jordan',
            fi: 'Jordania',
            sv: 'Jordanien',
        },
    },
    JP: {
        countryCode: 'JP',
        countryName: {
            en: 'Japan',
            fi: 'Japani',
            sv: 'Japan',
        },
    },
    KE: {
        countryCode: 'KE',
        countryName: {
            en: 'Kenya',
            fi: 'Kenia',
            sv: 'Kenya',
        },
    },
    KG: {
        countryCode: 'KG',
        countryName: {
            en: 'Kyrgyzstan',
            fi: 'Kirgisia',
            sv: 'Kirgizistan',
        },
    },
    KH: {
        countryCode: 'KH',
        countryName: {
            en: 'Cambodia',
            fi: 'Kambodža',
            sv: 'Kambodja',
        },
    },
    KI: {
        countryCode: 'KI',
        countryName: {
            en: 'Kiribati',
            fi: 'Kiribati',
            sv: 'Kiribati',
        },
    },
    KM: {
        countryCode: 'KM',
        countryName: {
            en: 'Comoros',
            fi: 'Komorit',
            sv: 'Komorerna',
        },
    },
    KN: {
        countryCode: 'KN',
        countryName: {
            en: 'Saint Kitts and Nevis',
            fi: 'Saint Kitts ja Nevis',
            sv: 'Saint Kitts och Nevis',
        },
    },
    KP: {
        countryCode: 'KP',
        countryName: {
            en: 'North Korea',
            fi: 'Pohjois-Korea',
            sv: 'Nordkorea',
        },
    },
    KR: {
        countryCode: 'KR',
        countryName: {
            en: 'South Korea',
            fi: 'Etelä-Korea',
            sv: 'Sydkorea',
        },
    },
    KW: {
        countryCode: 'KW',
        countryName: {
            en: 'Kuwait',
            fi: 'Kuwait',
            sv: 'Kuwait',
        },
    },
    KY: {
        countryCode: 'KY',
        countryName: {
            en: 'Cayman Islands',
            fi: 'Caymansaaret',
            sv: 'Caymanöarna',
        },
    },
    KZ: {
        countryCode: 'KZ',
        countryName: {
            en: 'Kazakhstan',
            fi: 'Kazakstan',
            sv: 'Kazakstan',
        },
    },
    LA: {
        countryCode: 'LA',
        countryName: {
            en: "Lao People's Democratic Republic",
            fi: 'Laos',
            sv: 'Laos',
        },
    },
    LB: {
        countryCode: 'LB',
        countryName: {
            en: 'Lebanon',
            fi: 'Libanon',
            sv: 'Libanon',
        },
    },
    LC: {
        countryCode: 'LC',
        countryName: {
            en: 'Saint Lucia',
            fi: 'Saint Lucia',
            sv: 'Saint Lucia',
        },
    },
    LI: {
        countryCode: 'LI',
        countryName: {
            en: 'Liechtenstein',
            fi: 'Liechtenstein',
            sv: 'Liechtenstein',
        },
    },
    LK: {
        countryCode: 'LK',
        countryName: {
            en: 'Sri Lanka',
            fi: 'Sri Lanka',
            sv: 'Sri Lanka',
        },
    },
    LR: {
        countryCode: 'LR',
        countryName: {
            en: 'Liberia',
            fi: 'Liberia',
            sv: 'Liberia',
        },
    },
    LS: {
        countryCode: 'LS',
        countryName: {
            en: 'Lesotho',
            fi: 'Lesotho',
            sv: 'Lesotho',
        },
    },
    LT: {
        countryCode: 'LT',
        countryName: {
            en: 'Lithuania',
            fi: 'Liettua',
            sv: 'Litauen',
        },
    },
    LU: {
        countryCode: 'LU',
        countryName: {
            en: 'Luxembourg',
            fi: 'Luxemburg',
            sv: 'Luxemburg',
        },
    },
    LV: {
        countryCode: 'LV',
        countryName: {
            en: 'Latvia',
            fi: 'Latvia',
            sv: 'Lettland',
        },
    },
    LY: {
        countryCode: 'LY',
        countryName: {
            en: 'Libya',
            fi: 'Libya',
            sv: 'Libyen',
        },
    },
    MA: {
        countryCode: 'MA',
        countryName: {
            en: 'Morocco',
            fi: 'Marokko',
            sv: 'Marocko',
        },
    },
    MC: {
        countryCode: 'MC',
        countryName: {
            en: 'Monaco',
            fi: 'Monaco',
            sv: 'Monaco',
        },
    },
    MD: {
        countryCode: 'MD',
        countryName: {
            en: 'Moldova',
            fi: 'Moldova',
            sv: 'Moldavien',
        },
    },
    ME: {
        countryCode: 'ME',
        countryName: {
            en: 'Montenegro',
            fi: 'Montenegro',
            sv: 'Montenegro',
        },
    },
    MF: {
        countryCode: 'MF',
        countryName: {
            en: 'Saint Martin (French part)',
            fi: 'Saint Martin (Ranska)',
            sv: 'Saint-Martin',
        },
    },
    MG: {
        countryCode: 'MG',
        countryName: {
            en: 'Madagascar',
            fi: 'Madagaskar',
            sv: 'Madagaskar',
        },
    },
    MH: {
        countryCode: 'MH',
        countryName: {
            en: 'Marshall Islands',
            fi: 'Marshallinsaaret',
            sv: 'Marshallöarna',
        },
    },
    MK: {
        countryCode: 'MK',
        countryName: {
            en: 'North Macedonia',
            fi: 'Pohjois-Makedonia',
            sv: 'Nordmakedonien',
        },
    },
    ML: {
        countryCode: 'ML',
        countryName: {
            en: 'Mali',
            fi: 'Mali',
            sv: 'Mali',
        },
    },
    MM: {
        countryCode: 'MM',
        countryName: {
            en: 'Myanmar',
            fi: 'Myanmar',
            sv: 'Myanmar',
        },
    },
    MN: {
        countryCode: 'MN',
        countryName: {
            en: 'Mongolia',
            fi: 'Mongolia',
            sv: 'Mongoliet',
        },
    },
    MO: {
        countryCode: 'MO',
        countryName: {
            en: 'Macao',
            fi: 'Macao',
            sv: 'Macao',
        },
    },
    MP: {
        countryCode: 'MP',
        countryName: {
            en: 'Northern Mariana Islands',
            fi: 'Pohjois-Mariaanit',
            sv: 'Nordmarianerna',
        },
    },
    MQ: {
        countryCode: 'MQ',
        countryName: {
            en: 'Martinique',
            fi: 'Martinique',
            sv: 'Martinique',
        },
    },
    MR: {
        countryCode: 'MR',
        countryName: {
            en: 'Mauritania',
            fi: 'Mauritania',
            sv: 'Mauretanien',
        },
    },
    MS: {
        countryCode: 'MS',
        countryName: {
            en: 'Montserrat',
            fi: 'Montserrat',
            sv: 'Montserrat',
        },
    },
    MT: {
        countryCode: 'MT',
        countryName: {
            en: 'Malta',
            fi: 'Malta',
            sv: 'Malta',
        },
    },
    MU: {
        countryCode: 'MU',
        countryName: {
            en: 'Mauritius',
            fi: 'Mauritius',
            sv: 'Mauritius',
        },
    },
    MV: {
        countryCode: 'MV',
        countryName: {
            en: 'Maldives',
            fi: 'Malediivit',
            sv: 'Maldiverna',
        },
    },
    MW: {
        countryCode: 'MW',
        countryName: {
            en: 'Malawi',
            fi: 'Malawi',
            sv: 'Malawi',
        },
    },
    MX: {
        countryCode: 'MX',
        countryName: {
            en: 'Mexico',
            fi: 'Meksiko',
            sv: 'Mexiko',
        },
    },
    MY: {
        countryCode: 'MY',
        countryName: {
            en: 'Malaysia',
            fi: 'Malesia',
            sv: 'Malaysia',
        },
    },
    MZ: {
        countryCode: 'MZ',
        countryName: {
            en: 'Mozambique',
            fi: 'Mosambik',
            sv: 'Moçambique',
        },
    },
    NA: {
        countryCode: 'NA',
        countryName: {
            en: 'Namibia',
            fi: 'Namibia',
            sv: 'Namibia',
        },
    },
    NC: {
        countryCode: 'NC',
        countryName: {
            en: 'New Caledonia',
            fi: 'Uusi-Kaledonia',
            sv: 'Nya Kaledonien',
        },
    },
    NE: {
        countryCode: 'NE',
        countryName: {
            en: 'Niger',
            fi: 'Niger',
            sv: 'Niger',
        },
    },
    NF: {
        countryCode: 'NF',
        countryName: {
            en: 'Norfolk Island',
            fi: 'Norfolkinsaari',
            sv: 'Norfolkön',
        },
    },
    NG: {
        countryCode: 'NG',
        countryName: {
            en: 'Nigeria',
            fi: 'Nigeria',
            sv: 'Nigeria',
        },
    },
    NI: {
        countryCode: 'NI',
        countryName: {
            en: 'Nicaragua',
            fi: 'Nicaragua',
            sv: 'Nicaragua',
        },
    },
    NL: {
        countryCode: 'NL',
        countryName: {
            en: 'Netherlands',
            fi: 'Alankomaat',
            sv: 'Nederländerna',
        },
    },
    NO: {
        countryCode: 'NO',
        countryName: {
            en: 'Norway',
            fi: 'Norja',
            sv: 'Norge',
        },
    },
    NP: {
        countryCode: 'NP',
        countryName: {
            en: 'Nepal',
            fi: 'Nepal',
            sv: 'Nepal',
        },
    },
    NR: {
        countryCode: 'NR',
        countryName: {
            en: 'Nauru',
            fi: 'Nauru',
            sv: 'Nauru',
        },
    },
    NU: {
        countryCode: 'NU',
        countryName: {
            en: 'Niue',
            fi: 'Niue',
            sv: 'Niue',
        },
    },
    NZ: {
        countryCode: 'NZ',
        countryName: {
            en: 'New Zealand',
            fi: 'Uusi-Seelanti',
            sv: 'Nya Zeeland',
        },
    },
    OM: {
        countryCode: 'OM',
        countryName: {
            en: 'Oman',
            fi: 'Oman',
            sv: 'Oman',
        },
    },
    PA: {
        countryCode: 'PA',
        countryName: {
            en: 'Panama',
            fi: 'Panama',
            sv: 'Panama',
        },
    },
    PE: {
        countryCode: 'PE',
        countryName: {
            en: 'Peru',
            fi: 'Peru',
            sv: 'Peru',
        },
    },
    PF: {
        countryCode: 'PF',
        countryName: {
            en: 'French Polynesia',
            fi: 'Ranskan Polynesia',
            sv: 'Franska Polynesien',
        },
    },
    PG: {
        countryCode: 'PG',
        countryName: {
            en: 'Papua New Guinea',
            fi: 'Papua-Uusi-Guinea',
            sv: 'Papua Nya Guinea',
        },
    },
    PH: {
        countryCode: 'PH',
        countryName: {
            en: 'Philippines',
            fi: 'Filippiinit',
            sv: 'Filippinerna',
        },
    },
    PK: {
        countryCode: 'PK',
        countryName: {
            en: 'Pakistan',
            fi: 'Pakistan',
            sv: 'Pakistan',
        },
    },
    PL: {
        countryCode: 'PL',
        countryName: {
            en: 'Poland',
            fi: 'Puola',
            sv: 'Polen',
        },
    },
    PM: {
        countryCode: 'PM',
        countryName: {
            en: 'Saint Pierre and Miquelon',
            fi: 'Saint-Pierre ja Miquelon',
            sv: 'Saint-Pierre och Miquelon',
        },
    },
    PN: {
        countryCode: 'PN',
        countryName: {
            en: 'Pitcairn',
            fi: 'Pitcairn',
            sv: 'Pitcairnöarna',
        },
    },
    PR: {
        countryCode: 'PR',
        countryName: {
            en: 'Puerto Rico',
            fi: 'Puerto Rico',
            sv: 'Puerto Rico',
        },
    },
    PS: {
        countryCode: 'PS',
        countryName: {
            en: 'Palestine',
            fi: 'Palestiina',
            sv: 'Palestina',
        },
    },
    PT: {
        countryCode: 'PT',
        countryName: {
            en: 'Portugal',
            fi: 'Portugali',
            sv: 'Portugal',
        },
    },
    PW: {
        countryCode: 'PW',
        countryName: {
            en: 'Palau',
            fi: 'Palau',
            sv: 'Palau',
        },
    },
    PY: {
        countryCode: 'PY',
        countryName: {
            en: 'Paraguay',
            fi: 'Paraguay',
            sv: 'Paraguay',
        },
    },
    QA: {
        countryCode: 'QA',
        countryName: {
            en: 'Qatar',
            fi: 'Qatar',
            sv: 'Qatar',
        },
    },
    RE: {
        countryCode: 'RE',
        countryName: {
            en: 'Réunion',
            fi: 'Réunion',
            sv: 'Réunion',
        },
    },
    RO: {
        countryCode: 'RO',
        countryName: {
            en: 'Romania',
            fi: 'Romania',
            sv: 'Rumänien',
        },
    },
    RS: {
        countryCode: 'RS',
        countryName: {
            en: 'Serbia',
            fi: 'Serbia',
            sv: 'Serbien',
        },
    },
    RU: {
        countryCode: 'RU',
        countryName: {
            en: 'Russian Federation',
            fi: 'Venäjä',
            sv: 'Ryssland',
        },
    },
    RW: {
        countryCode: 'RW',
        countryName: {
            en: 'Rwanda',
            fi: 'Ruanda',
            sv: 'Rwanda',
        },
    },
    SA: {
        countryCode: 'SA',
        countryName: {
            en: 'Saudi Arabia',
            fi: 'Saudi-Arabia',
            sv: 'Saudiarabien',
        },
    },
    SB: {
        countryCode: 'SB',
        countryName: {
            en: 'Solomon Islands',
            fi: 'Salomonsaaret',
            sv: 'Salomonöarna',
        },
    },
    SC: {
        countryCode: 'SC',
        countryName: {
            en: 'Seychelles',
            fi: 'Seychellit',
            sv: 'Seychellerna',
        },
    },
    SD: {
        countryCode: 'SD',
        countryName: {
            en: 'Sudan',
            fi: 'Sudan',
            sv: 'Sudan',
        },
    },
    SE: {
        countryCode: 'SE',
        countryName: {
            en: 'Sweden',
            fi: 'Ruotsi',
            sv: 'Sverige',
        },
    },
    SG: {
        countryCode: 'SG',
        countryName: {
            en: 'Singapore',
            fi: 'Singapore',
            sv: 'Singapore',
        },
    },
    SH: {
        countryCode: 'SH',
        countryName: {
            en: 'Saint Helena, Ascension and Tristan da Cunha',
            fi: 'Saint Helena, Ascension ja Tristan da Cunha',
            sv: 'Sankta Helena, Ascension och Tristan da Cunha',
        },
    },
    SI: {
        countryCode: 'SI',
        countryName: {
            en: 'Slovenia',
            fi: 'Slovenia',
            sv: 'Slovenien',
        },
    },
    SJ: {
        countryCode: 'SJ',
        countryName: {
            en: 'Svalbard and Jan Mayen',
            fi: 'Svalbard ja Jan Mayen',
            sv: 'Svalbard och Jan Mayen',
        },
    },
    SK: {
        countryCode: 'SK',
        countryName: {
            en: 'Slovakia',
            fi: 'Slovakia',
            sv: 'Slovakien',
        },
    },
    SL: {
        countryCode: 'SL',
        countryName: {
            en: 'Sierra Leone',
            fi: 'Sierra Leone',
            sv: 'Sierra Leone',
        },
    },
    SM: {
        countryCode: 'SM',
        countryName: {
            en: 'San Marino',
            fi: 'San Marino',
            sv: 'San Marino',
        },
    },
    SN: {
        countryCode: 'SN',
        countryName: {
            en: 'Senegal',
            fi: 'Senegal',
            sv: 'Senegal',
        },
    },
    SO: {
        countryCode: 'SO',
        countryName: {
            en: 'Somalia',
            fi: 'Somalia',
            sv: 'Somalia',
        },
    },
    SR: {
        countryCode: 'SR',
        countryName: {
            en: 'Suriname',
            fi: 'Suriname',
            sv: 'Surinam',
        },
    },
    SS: {
        countryCode: 'SS',
        countryName: {
            en: 'South Sudan',
            fi: 'Etelä-Sudan',
            sv: 'Sydsudan',
        },
    },
    ST: {
        countryCode: 'ST',
        countryName: {
            en: 'Sao Tome and Principe',
            fi: 'São Tomé ja Príncipe',
            sv: 'São Tomé och Príncipe',
        },
    },
    SV: {
        countryCode: 'SV',
        countryName: {
            en: 'El Salvador',
            fi: 'El Salvador',
            sv: 'El Salvador',
        },
    },
    SX: {
        countryCode: 'SX',
        countryName: {
            en: 'Sint Maarten (Dutch part)',
            fi: 'Sint Maarten (Alankomaat)',
            sv: 'Sint Maarten',
        },
    },
    SY: {
        countryCode: 'SY',
        countryName: {
            en: 'Syrian Arab Republic',
            fi: 'Syyria',
            sv: 'Syrien',
        },
    },
    SZ: {
        countryCode: 'SZ',
        countryName: {
            en: 'Eswatini',
            fi: 'Swazimaa',
            sv: 'Swaziland',
        },
    },
    TC: {
        countryCode: 'TC',
        countryName: {
            en: 'Turks and Caicos Islands',
            fi: 'Turks- ja Caicossaaret',
            sv: 'Turks- och Caicosöarna',
        },
    },
    TD: {
        countryCode: 'TD',
        countryName: {
            en: 'Chad',
            fi: 'Tšad',
            sv: 'Tchad',
        },
    },
    TF: {
        countryCode: 'TF',
        countryName: {
            en: 'French Southern Territories',
            fi: 'Ranskan eteläiset alueet',
            sv: 'Franska sydterritorierna',
        },
    },
    TG: {
        countryCode: 'TG',
        countryName: {
            en: 'Togo',
            fi: 'Togo',
            sv: 'Togo',
        },
    },
    TH: {
        countryCode: 'TH',
        countryName: {
            en: 'Thailand',
            fi: 'Thaimaa',
            sv: 'Thailand',
        },
    },
    TJ: {
        countryCode: 'TJ',
        countryName: {
            en: 'Tajikistan',
            fi: 'Tadžikistan',
            sv: 'Tadzjikistan',
        },
    },
    TK: {
        countryCode: 'TK',
        countryName: {
            en: 'Tokelau',
            fi: 'Tokelau',
            sv: 'Tokelauöarna',
        },
    },
    TL: {
        countryCode: 'TL',
        countryName: {
            en: 'Timor-Leste',
            fi: 'Itä-Timor',
            sv: 'Östtimor',
        },
    },
    TM: {
        countryCode: 'TM',
        countryName: {
            en: 'Turkmenistan',
            fi: 'Turkmenistan',
            sv: 'Turkmenistan',
        },
    },
    TN: {
        countryCode: 'TN',
        countryName: {
            en: 'Tunisia',
            fi: 'Tunisia',
            sv: 'Tunisien',
        },
    },
    TO: {
        countryCode: 'TO',
        countryName: {
            en: 'Tonga',
            fi: 'Tonga',
            sv: 'Tonga',
        },
    },
    TR: {
        countryCode: 'TR',
        countryName: {
            en: 'Türkiye',
            fi: 'Turkki',
            sv: 'Turkiet',
        },
    },
    TT: {
        countryCode: 'TT',
        countryName: {
            en: 'Trinidad and Tobago',
            fi: 'Trinidad ja Tobago',
            sv: 'Trinidad och Tobago',
        },
    },
    TV: {
        countryCode: 'TV',
        countryName: {
            en: 'Tuvalu',
            fi: 'Tuvalu',
            sv: 'Tuvalu',
        },
    },
    TW: {
        countryCode: 'TW',
        countryName: {
            en: 'Taiwan',
            fi: 'Taiwan',
            sv: 'Taiwan',
        },
    },
    TZ: {
        countryCode: 'TZ',
        countryName: {
            en: 'Tanzania',
            fi: 'Tansania',
            sv: 'Tanzania',
        },
    },
    UA: {
        countryCode: 'UA',
        countryName: {
            en: 'Ukraine',
            fi: 'Ukraina',
            sv: 'Ukraina',
        },
    },
    UG: {
        countryCode: 'UG',
        countryName: {
            en: 'Uganda',
            fi: 'Uganda',
            sv: 'Uganda',
        },
    },
    UM: {
        countryCode: 'UM',
        countryName: {
            en: 'United States Minor Outlying Islands',
            fi: 'Yhdysvaltain pienet erillissaaret',
            sv: 'Förenta staternas mindre öar i Oceanien och Västindien',
        },
    },
    US: {
        countryCode: 'US',
        countryName: {
            en: 'United States of America',
            fi: 'Yhdysvallat',
            sv: 'USA',
        },
    },
    UY: {
        countryCode: 'UY',
        countryName: {
            en: 'Uruguay',
            fi: 'Uruguay',
            sv: 'Uruguay',
        },
    },
    UZ: {
        countryCode: 'UZ',
        countryName: {
            en: 'Uzbekistan',
            fi: 'Uzbekistan',
            sv: 'Uzbekistan',
        },
    },
    VA: {
        countryCode: 'VA',
        countryName: {
            en: 'Holy See',
            fi: 'Vatikaanivaltio',
            sv: 'Vatikanstaten',
        },
    },
    VC: {
        countryCode: 'VC',
        countryName: {
            en: 'Saint Vincent and the Grenadines',
            fi: 'Saint Vincent ja Grenadiinit',
            sv: 'Saint Vincent och Grenadinerna',
        },
    },
    VE: {
        countryCode: 'VE',
        countryName: {
            en: 'Venezuela',
            fi: 'Venezuela',
            sv: 'Venezuela',
        },
    },
    VG: {
        countryCode: 'VG',
        countryName: {
            en: 'Virgin Islands (British)',
            fi: 'Brittiläiset Neitsytsaaret',
            sv: 'Brittiska Jungfruöarna',
        },
    },
    VI: {
        countryCode: 'VI',
        countryName: {
            en: 'Virgin Islands (U.S.)',
            fi: 'Yhdysvaltain Neitsytsaaret',
            sv: 'Amerikanska Jungfruöarna',
        },
    },
    VN: {
        countryCode: 'VN',
        countryName: {
            en: 'Viet Nam',
            fi: 'Vietnam',
            sv: 'Vietnam',
        },
    },
    VU: {
        countryCode: 'VU',
        countryName: {
            en: 'Vanuatu',
            fi: 'Vanuatu',
            sv: 'Vanuatu',
        },
    },
    WF: {
        countryCode: 'WF',
        countryName: {
            en: 'Wallis and Futuna',
            fi: 'Wallis ja Futunasaaret',
            sv: 'Wallis- och Futunaöarna',
        },
    },
    WS: {
        countryCode: 'WS',
        countryName: {
            en: 'Samoa',
            fi: 'Samoa',
            sv: 'Samoa',
        },
    },
    YE: {
        countryCode: 'YE',
        countryName: {
            en: 'Yemen',
            fi: 'Jemen',
            sv: 'Jemen',
        },
    },
    YT: {
        countryCode: 'YT',
        countryName: {
            en: 'Mayotte',
            fi: 'Mayotte',
            sv: 'Mayotte',
        },
    },
    ZA: {
        countryCode: 'ZA',
        countryName: {
            en: 'South Africa',
            fi: 'Etelä-Afrikka',
            sv: 'Sydafrika',
        },
    },
    ZM: {
        countryCode: 'ZM',
        countryName: {
            en: 'Zambia',
            fi: 'Sambia',
            sv: 'Zambia',
        },
    },
    ZW: {
        countryCode: 'ZW',
        countryName: {
            en: 'Zimbabwe',
            fi: 'Zimbabwe',
            sv: 'Zimbabwe',
        },
    },
};
export const countryData = countryDataRaw;
//# sourceMappingURL=countryData.js.map